var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-container","dusk":"app"}},[_c('div',{attrs:{"id":"app-route-wrapper"}},[_c('main',{staticClass:"main-content container-lg",staticStyle:{"box-shadow":"#ccc 0px 2px 10px"}},[_c('Home'),_c('Footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }